export default "__VITE_ASSET__$5FAqjPS__"